// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1957":"96a4d042dd15d21b005b","4473":"6009e669b1a0737a2378"}[chunkId] + "";
};